import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../components/layout';
import SEO from '../components/seo';

const TeamPage = () => {
  return (
    <Layout>
      <article>
        <h2>Наші досягнення</h2>

        <div className="grid top-spacing-big">
          <div className="grid__item">
            <StaticImage
              className="image"
              layout="constrained"
              width={700}
              formats={['auto', 'webp', 'avif']}
              src="../images/diploma-1.jpg"
              alt="Грамота"
            />
          </div>
          <div className="grid__item">
            <StaticImage
              className="image"
              layout="constrained"
              width={700}
              formats={['auto', 'webp', 'avif']}
              src="../images/diploma-2.jpg"
              alt="Диплом"
            />
          </div>
          <div className="grid__item">
            <StaticImage
              className="image"
              layout="constrained"
              width={700}
              formats={['auto', 'webp', 'avif']}
              src="../images/diploma-3.jpg"
              alt="Диплом"
            />
          </div>
        </div>
      </article>
    </Layout>
  );
};

export default TeamPage;

export const Head = () => <SEO title="Наші досягнення" />;
